import request from "@/utils/request";

export function getDictEnumAll() {
  return request({ url: `/common/dictEnumMapAll`, method: "post" });
}

export function getDictMapAll() {
  return request({ url: `/common/dict/allMap`, method: "post" });
}

export function getToken() {
  return request({ url: `/common/getToken`, method: "post" });
}

export function sendCode(data) {
  return request({ url: `/common/sendCode`, method: "post", data: data });
}

export function getBannerList(type) {
  return request({ url: `/banner/${type}/list`, method: "get" });
}

export function getAssetsList() {
  return request({ url: `/assets/list`, method: "get" });
}

export function upload(data) {
  return request({ url: `/common/uploadPre`, method: "post", data: data });
}

export function getDomainAgentNumber() {
  return request({ url: `/getDomainAgentNumber`, method: "get" });
}

export function getCountryList() {
  return request({ url: `/country/list`, method: 'get' })
}
export function getTranslationList() {
  return request({ url: `/translation/list`, method: 'get' })
}